//@ts-check
import { createContext } from "react";
export const Application = createContext(null);
